// Always use the full report total, never the filtered or paginated row sum.
export const getSharePercent = (count: number, total: number): number | null =>
    Number.isFinite(count) && Number.isFinite(total) && count >= 0 && total > 0
        ? Math.min(100, count / total * 100)
        : null;

export const formatSharePercent = (share: number | null) => share === null ? '—'
    : share > 0 && share < 0.1 ? '<0.1%'
        : `${share.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`;

export const csvSharePercent = (count: number, total: number) => {
    const share = getSharePercent(count, total);
    return share === null ? '' : Number(share.toFixed(4));
};
